import styled from "styled-components";
import { Modal } from "antd";

export const ModalContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: none;
  z-index: 51;
  left: 0;
  align-items: center;
  justify-content: center;
  overflow-y: auto;

  .modal-overlay {
    background: rgba(0, 0, 0, 0.8);
    left: 0;
    z-index: 100;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .modal-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    min-height: 250px;
    flex-direction: column;
    overflow: hidden;
    height: auto;
    border-radius: 30px;
    background: #fff;
    z-index: 1;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  }
  &.isVisible {
    display: flex;
  }
`;

export const FeedbackModal = styled(Modal)`
  .ant-modal-content {
    top: -50px;
  }
  .ant-modal-body {
    max-height: 80vh;
    overflow-y: auto;
    border-top-width: 0.5px;
    border-top-color: rgb(193 193 193);
  }
  .ant-modal-body > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
    p {
      margin: 15px 5px 0px 0px;
      text-align: center;
      font-size: 1rem;
    }
  }
`;
